import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import {
  ProfileFeature,
  ProfileRole,
  Tenant
} from 'src/app/store/states/auth.state';
import { environment } from 'src/environments/environment';
import { CubeAuth } from 'src/app/modules_msal/CubeAuth';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token: BehaviorSubject<string | undefined> = new BehaviorSubject<
    string | undefined
  >(undefined);
  profile: BehaviorSubject<string | undefined> = new BehaviorSubject<
    string | undefined
  >(undefined);
  constructor(
    private readonly http: HttpClient
  ) {}

  tenants(uniqueId: string): Observable<Array<Tenant>> {
    return this.http.get<Array<Tenant>>(
      `${environment.admin_tool_url}/users/${uniqueId}/solutions/${environment.solution}/tenants`
    );
  }

  roles(uniqueId: string, tenant: string): Observable<Array<ProfileRole>> {
    return this.http.get<Array<ProfileRole>>(
      `${environment.admin_tool_url}/tenants/${tenant}/users/${uniqueId}/platforms/CUBE/solutions/${environment.solution}/roles`
    );
  }

  features(role: string, tenant: string): Observable<Array<ProfileFeature>> {
    return this.http.get<Array<ProfileFeature>>(
      `${environment.admin_tool_url}/tenants/${tenant}/roles/${role}/platforms/CUBE/solutions/${environment.solution}/features`
    );
  }
  login() {
    /*     this.msalService.loginRedirect();
     */
    CubeAuth.enableADB2C(environment.b2cPolicies.tenant, environment.b2cPolicies.clientId, environment.b2cPolicies.names.signUpSignIn, environment.b2cPolicies.redirectUri);
    CubeAuth.setLogutRedirectUri(environment.b2cPolicies.postLogoutRedirectUri);

    CubeAuth.onADB2CNewToken = (idToken: any, expires: any, profileInfo: any) => {
      this.token.next(idToken);
      this.profile.next(profileInfo.name);
    };

    CubeAuth.auth();
  }

  resourceNeedsToken(request_url: string): boolean {
    return environment.bypass_auth_token_resources.every((resource) => !request_url.startsWith(resource) && !request_url.includes('/assets/i18n/'));
  }
  logout() {
    CubeAuth.logout();
    this.profile.next(undefined);
    this.token.next(undefined);
/*     this.msalService.logoutRedirect();
 */  }

/*   getActiveAccount(): AccountInfo | null {
    return this.msalService.instance.getActiveAccount();
  }

  acquireTokenSilent(request: SilentRequest): Observable<AuthenticationResult> {
    return this.msalService.acquireTokenSilent(request);
  }

  acquireTokenRedirect(request: RedirectRequest): void {
    this.msalService.acquireTokenRedirect(request);
  } */
/* 
  checkAndSetActiveAccount() {

    const activeAccount = this.getActiveAccount();
    const allAccounts = this.msalService.instance.getAllAccounts();

    if (!activeAccount && allAccounts.length > 0) {
      this.msalService.instance.setActiveAccount(allAccounts[0]);
    }
  } */
    cloneRequest(req: HttpRequest<unknown>, idToken: string, append_token: boolean): HttpRequest<unknown> {
      if (append_token) {
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${idToken}`,
          },
        });
  
        return clonedReq;
      } else {
        return req;
      }
    }
}
